
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"6","height":"6","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"opacity":".4","d":"M2.71 2.404L.862 1.718.526 2.726l1.904.532-1.232 1.54.854.63 1.092-1.652 1.092 1.652.854-.63-1.218-1.54 1.904-.532-.336-1.008-1.848.686.084-1.96h-1.05l.084 1.96z","fill":"#111"}})])
      }
    
      }
    